// English strings for recurring visits (PB-04-02) and room booking policy (PB-12-03); recurrence &
// rooms stream, PD-470 – PD-479. Arabic: ar-recurrence.ts.
export const enRecurrence = {
  // ------------------------------------------------------------ API and validation
  'api.roomCapacityWarning': 'This destination holds {capacity} people; the visit has {count}. Its booking policy allows this only if you confirm.',
  'api.seriesRoomWarning': 'Some occurrences have more people than their destination holds. Confirm to continue.',
  'api.seriesImpact': 'This change withdraws approvals of later occurrences. Review and confirm.',
  'api.notSeries': 'This visit is not part of a recurring series.',
  'api.occurrenceClosed': 'This occurrence is cancelled or has ended. Choose a later occurrence.',
  'api.seriesOccurrencesForbidden': 'You cannot change every later occurrence of this series, so nothing was changed.',
  'v.recurrenceEnd': 'Choose an end date or a number of occurrences.',
  'v.exclusionUnmatched': 'These dates are not occurrences of the series: {dates}.',
  'v.bookingPolicyNotApplicable': 'Only rooms, zones, parking and other destinations can be booked.',

  // ------------------------------------------------------------ recurrence editor (PB-04-02)
  'rr.repeat': 'Repeat',
  'rr.frequency': 'Frequency',
  'rr.frequency.weekly': 'Weekly',
  'rr.frequency.monthly': 'Monthly',
  'rr.monthly.by': 'Repeat on',
  'rr.monthly.dayOfMonth': 'The same day of the month',
  'rr.monthly.nthWeekday': 'The same weekday of the month',
  'rr.day': 'Day of the month',
  'rr.nth': 'Which',
  'rr.nth.1': 'first',
  'rr.nth.2': 'second',
  'rr.nth.3': 'third',
  'rr.nth.4': 'fourth',
  'rr.nth.5': 'fifth',
  'rr.nth.last': 'last',
  'rr.weekday': 'Weekday',
  'rr.weekdayLong.1': 'Monday',
  'rr.weekdayLong.2': 'Tuesday',
  'rr.weekdayLong.3': 'Wednesday',
  'rr.weekdayLong.4': 'Thursday',
  'rr.weekdayLong.5': 'Friday',
  'rr.weekdayLong.6': 'Saturday',
  'rr.weekdayLong.7': 'Sunday',
  'rr.end': 'Ends',
  'rr.end.until': 'On a date',
  'rr.end.count': 'After a number of occurrences',
  'rr.until': 'End date',
  'rr.count': 'Number of occurrences',
  'rr.countHint': 'Excluded dates count towards this number; dates that do not exist do not.',
  'rr.exclusions': 'Skip these dates',
  'rr.exclusionsHint': 'Dates of the series with no visit, for example a public holiday.',
  'rr.exclusionDate': 'Date to skip',
  'rr.addExclusion': 'Add date',
  'rr.removeExclusion': 'Remove {date}',
  'rr.preview': 'Occurrences',
  'rr.previewCount': { one: '{count} occurrence', other: '{count} occurrences' },
  'rr.previewMore': '… and {count} more',
  'rr.previewLoading': 'Working out the dates…',
  'rr.previewIncomplete': 'Choose a start date, the pattern and how the series ends to see the dates.',
  'rr.excludedTitle': 'Skipped by you',
  'rr.skippedTitle': 'Dates that do not exist (skipped, never moved)',
  'rr.skipped.no_such_day': '{month}: the month has no such day',
  'rr.skipped.no_such_weekday': '{month}: the month has no such weekday',
  'rr.dstNote': 'Each occurrence keeps the same local time in {zone}, also across clock changes.',

  // ------------------------------------------------------------ this / this-and-future (PD-472 – PD-474)
  'rr.scope.legend': 'Apply this change to',
  'rr.scope.this': 'This occurrence only',
  'rr.scope.following': 'This and all later occurrences',
  'rr.scope.followingHint': 'Earlier occurrences and their history stay as they are. Each later occurrence is checked and, where the change is material, approved again on its own.',
  'rr.scope.visitorsNote': 'To add visitors, change one occurrence at a time.',
  'rr.impactBody': { one: 'Approvals of {count} occurrence will be requested again ({decisions} decisions withdrawn). Changed: {fields}.', other: 'Approvals of {count} occurrences will be requested again ({decisions} decisions withdrawn). Changed: {fields}.' },
  'rr.result.title': 'Series change',
  'rr.result.split': { one: 'Changed from {date}. {count} earlier occurrence is kept unchanged.', other: 'Changed from {date}. {count} earlier occurrences are kept unchanged.' },
  'rr.result.inPlace': 'Changed from {date}.',
  'rr.result.cancelled': { one: 'Cancelled from {date}. {count} earlier occurrence is kept unchanged.', other: 'Cancelled from {date}. {count} earlier occurrences are kept unchanged.' },
  'rr.outcome.updated': 'updated',
  'rr.outcome.unchanged': 'no change',
  'rr.outcome.cancelled': 'cancelled',
  'rr.outcome.failed': 'not changed — {message}',
  'rr.viewSeries': 'View series',

  // ------------------------------------------------------------ cancel
  'rr.cancel.scope': 'Cancel',
  'rr.cancel.this': 'This occurrence only',
  'rr.cancel.following': 'This and all later occurrences',
  'rr.cancel.followingHint': 'Earlier occurrences stay as they are. Each later occurrence is cancelled on its own; people onsite stay onsite until their departure is recorded.',

  // ------------------------------------------------------------ series view
  'rr.series.title': 'Recurring series',
  'rr.series.intro': 'Every occurrence is its own visit with its own approvals and links. Changing one never cancels the others.',
  'rr.series.col.date': 'Occurrence',
  'rr.series.col.when': 'When ({zone})',
  'rr.series.col.visit': 'Visit',
  'rr.series.col.planning': 'Status',
  'rr.series.col.approval': 'Approvals',
  'rr.series.hidden': { one: '{count} occurrence is not shown because you cannot see it.', other: '{count} occurrences are not shown because you cannot see them.' },
  'rr.series.parts': 'Parts of this series',
  'rr.series.part.original': 'Original, from {date}',
  'rr.series.part.continued': 'Continued from {date}',
  'rr.series.ended.split': 'Changed from {date} onwards (continued as a new part)',
  'rr.series.ended.cancelled': 'Cancelled from {date} onwards',
  'rr.series.rule.weekly': 'Weekly on {days}',
  'rr.series.rule.monthlyDay': 'Monthly on day {day}',
  'rr.series.rule.monthlyNth': 'Monthly on the {nth} {weekday}',
  'rr.series.rule.until': 'until {date}',
  'rr.series.rule.count': { one: '{count} occurrence', other: '{count} occurrences' },
  'rr.series.back': 'Back to the visit',
  'rr.series.empty': 'No occurrences.',

  // ------------------------------------------------------------ room booking policy (PB-12-03)
  'rr.roomWarn.title': 'More people than the destination holds',
  'rr.roomWarn.record': 'If you continue, your confirmation is recorded on the visit.',
  'rr.roomWarn.item': '{date}: holds {capacity}, the visit has {count}',
  'rr.roomWarn.confirm': 'Continue over capacity',
  'rr.roomWarnings.title': 'Capacity warnings confirmed',
  'rr.roomWarnings.item': '{name} confirmed {count} people for a destination that holds {capacity} ({at})',
  'loc.field.bookingPolicy': 'Booking policy',
  'loc.field.bookingPolicyHint': 'What happens when a visit overlaps another booking or has more people than the capacity. A change applies to bookings made afterwards.',
  'loc.booking.block': 'Block: no overlapping bookings; over capacity is refused',
  'loc.booking.warn': 'Warn: overlaps allowed; over capacity needs confirmation',
  'loc.booking.none': 'Not booked: capacity is for information only',
  'loc.bookingShort.block': 'Blocks overlaps',
  'loc.bookingShort.warn': 'Warns',
  'loc.bookingShort.none': 'Not booked',
} as const;
